import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from 'react';
const InfoIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 17.9973C11.3869 17.9973 13.6761 17.0491 15.364 15.3613C17.0518 13.6734 18 11.3843 18 8.99731C18 6.61037 17.0518 4.32118 15.364 2.63335C13.6761 0.945526 11.3869 -0.00268555 9 -0.00268555C6.61305 -0.00268555 4.32387 0.945526 2.63604 2.63335C0.948212 4.32118 0 6.61037 0 8.99731C0 11.3843 0.948212 13.6734 2.63604 15.3613C4.32387 17.0491 6.61305 17.9973 9 17.9973ZM10.0463 7.40881L7.47 7.73169L7.37775 8.15919L7.884 8.25256C8.21475 8.33131 8.28 8.45056 8.208 8.78019L7.37775 12.6817C7.1595 13.6908 7.49588 14.1656 8.28675 14.1656C8.89988 14.1656 9.612 13.8821 9.93488 13.4928L10.0339 13.0248C9.80888 13.2228 9.48037 13.3016 9.26213 13.3016C8.95275 13.3016 8.84025 13.0844 8.92013 12.7019L10.0463 7.40881ZM9 6.18481C9.29837 6.18481 9.58452 6.06629 9.7955 5.85531C10.0065 5.64433 10.125 5.35818 10.125 5.05981C10.125 4.76145 10.0065 4.4753 9.7955 4.26432C9.58452 4.05334 9.29837 3.93481 9 3.93481C8.70163 3.93481 8.41548 4.05334 8.2045 4.26432C7.99353 4.4753 7.875 4.76145 7.875 5.05981C7.875 5.35818 7.99353 5.64433 8.2045 5.85531C8.41548 6.06629 8.70163 6.18481 9 6.18481Z",
    fill: color
  }));
};
export default InfoIcon;